const planContainer = {
  wordWrap: 'break-word',
  backgroundClip: 'border-box',
  border: '1px solid rgba(0,0,0,.125)',
  borderRadius: '0.25rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  position: 'relative',
  textAlign: 'center',
};

// status
const cardRegistered = {
  backgroundColor: '#d1e7dd',
  fontWeight: 'bold',
};

const cardNotRegistered = {
  backgroundColor: 'crimson',
  color: 'white',
  fontWeight: 'bold',
};

const isLowerPlan = {
  ...planContainer,
  backgroundColor: '#e2e3e5',
};

const isNotLowerPlan = {
  ...planContainer,
  backgroundColor: 'white',
};

const isActivePlan = {
  ...planContainer,
  backgroundColor: '#cfe2ff',
  border: '4px solid #dc5e35',
};

export default {
  cardRegistered,
  cardNotRegistered,
  isActivePlan,
  isLowerPlan,
  isNotLowerPlan,
};
